import script from "./AppInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInfo.vue?vue&type=script&setup=true&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=020ae7d1&lang=scss"
import "./AppInfo.vue?vue&type=style&index=1&id=020ae7d1&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020ae7d1"]])

export default __exports__